import { ApiHttpError } from '@/types';

/**
 * BaseResponse `{ result }` 信封拆解 — 共用 SoT(R81 API 重構階段 1,docs/51 主題 1)。
 * =============================================================================
 * 原本 12 個 `http*Service` 各自抄一份
 *   `if (!env.result) throw new ApiHttpError(500, { code: 'MISSING_RESULT', ... })`
 * (production grep `code: 'MISSING_RESULT'` ≈ 36 處)。從 `httpBillingService` 既有最乾淨的
 * 泛型實作升格到此單一檔(刻意**不**塞進 `httpApiClient` — transport core 只管 fetch / auth /
 * CSRF / error-normalize,envelope-shape 解讀屬上一層契約)。日後加 Sentry breadcrumb /
 * trace_id / 統一 log 也收斂在這一處。
 *
 * **契約破裂(BE 回 2xx 卻缺 result)一律 500 `MISSING_RESULT`**;`label`(如 `'assets.list'`)
 * 由 caller 帶進訊息方便定位是哪支 endpoint。
 *
 * 注意:用 `=== null || === undefined` 而非 `!result` —— 允許 falsy 但有效的 result
 * (`0` / `''` / `false`);實務上 result 多是物件 DTO,但此判定更精準不誤殺。
 *
 * @param env  BE envelope(`{ result?: T | null }`,可能 null/undefined)
 * @param label 呼叫點標籤(`'<service>.<method>'`),進缺值錯誤訊息
 * @returns 非空的 `env.result`
 * @throws {ApiHttpError} 500 `MISSING_RESULT` — result 缺值(契約破裂)
 */
export function unwrapResult<T>(
  env: { result?: T | null } | null | undefined,
  label: string,
): T {
  const result = env?.result;
  if (result === null || result === undefined) {
    throw new ApiHttpError(500, {
      code: 'MISSING_RESULT',
      message: `${label} BE response missing result envelope`,
    });
  }
  return result;
}
